<template>
        <div class="main__input" :class="`dir__${direction}`">
            <label v-if="label" ><span class="">{{ label }} <span v-if="required" class="required_mark">*</span></span><PopOver v-if="hasPopOver" v-bind="popOver"/></label>
            <textarea v-if="multiline"  :type="type" :value="value" :rows="multiline"  :placeholder="hint" @input="$emit('input',$event.target.value)"></textarea>
            <input v-else  :type="type" multiple  :disabled="disabled" :value="value" autofill="off" :autocomplete="autocomplete" :placeholder="hint" :style="inputStyle" @input="$emit('input',$event.target.value)" step="0.01">
            <small  v-if="error">{{ error }}</small>
        </div>
</template>
<script>
import PopOver from './Popover.vue'
export default {
    components : {PopOver},
    props: {
        error:{ type: String, default: null },
        autocomplete:{ type: String, default: 'off' },
        multiline: { type: Number, default: 0 },
        type: { type: String, default: 'text' },
        disabled : { type : Boolean, default : false},
        label: { type: String, default: null },
        hint: { type: String, default: null },
        name: { type: String, default: null },
        // value:  null,
        value:  [String, Number],
        padding : { type : Object, default : () => ({x : .7, y : .2})},
        // width : { type : Number, default : null},
        required : { type : Boolean, default : false},
        direction : { type : String, default : 'col'},
        borderColor : { tyep : String, default  : "#dbdbdb"},
        borderWidth : { tyep : Number, default  : 1},
        hasPopOver : { type: Boolean, default: false},
        popOver : { type:Object, default :null}
    },
    mounted() {
        this.$emit('input', this.inputValue)
    },
    computed  : { 
        inputValue(){ return this.value == undefined || !this.value ? this.type == 'number' ? 0 : '' : this.value; },
        inputStyle() {
            return {
                padding : `${this.padding.y}rem ${this.padding.x}rem`,
                // width : this.width ? this.width : '100%',
                'border-color' : this.borderColor ? this.borderColor : "#dbdbdb" ,
                'border-width' : this.borderWidth + 'px',
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .main__input {
        display : flex;
        position: relative;
        margin : .5rem 0;
    }
    .dir__col {
        flex-direction : column;
    }
    .dir__row {
        flex-direction : row;
        align-items : center;
        label {
            padding : 0 .5rem;
            margin : 0;
         
        }
    }
    label {
        padding : 0 .5rem;
        margin : 0;
        display:flex;
        
    }
    .main__input > label{
        position : relative;
         }
    .main__input input::placeholder{
        color: rgba(8, 8, 8, 0.301);
        font-size: .8rem;
    }
    input {
        outline : none;
        border : .1rem solid #dbdbdb;
        border-radius: .3rem;
        font-size: 1rem;
        width : 100%;
        &:focus{
            background-color: #ffffff;
            outline : none;
            border-color: #7367f0 !important;
            box-shadow : 0 3px 10px 0 #22292f1a;
        }
    }
    small, .required_mark {
        color : red;
        white-space: nowrap;
    }
    .required_mark {
        position: absolute;
        top : -.3rem;
    }
    textarea {
        border : 1px solid #d6d5d5;
        border-radius: .3rem;
        padding : .5rem;
        &:focus{
            background-color: #ffffff;
            outline : none;
            border-color: #7367f0 !important;
            box-shadow : 0 3px 10px 0 #22292f1a;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/global/Input.vue